const EMPLOYEES_LIST_MESSAGES = {
  LIST_FAILURE: "For some reason list couldn't be loaded",
  HEADING: 'Employees',
  CAPTION: 'View & manage all your Employees profiles',
}

export default EMPLOYEES_LIST_MESSAGES
